import { render, staticRenderFns } from "./Chatbox.vue?vue&type=template&id=4055d2dc&lang=pug&"
import script from "./Chatbox.vue?vue&type=script&lang=ts&"
export * from "./Chatbox.vue?vue&type=script&lang=ts&"
import style0 from "./Chatbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports